/* eslint-disable no-mixed-operators */
import React, { useRef, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import { amOrPm } from "../../../../global/utils/amOrPm";
import CardTemplate from "../../Genericos/CardTemplate/CardTemplate";
import camelize from "../../../../global/utils/camelize";
import AlertIcon from "../../../assets/images/generico/AlertIcon";
import TurnoVideoConsultaIcon from "../../../assets/images/generico/TurnoVideoConsultaIcon";
import VideoConsultaIcon from "../../../assets/images/generico/VideoConsultaIcon";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import "./CardVideoLlamada.css";
import {
  limpiarTipoTurno,
  wsCambioEstadoVideoLlamada,
} from "../../../context/Actions/turnos/turnosPaciente";
import { wsGetValidaCancelacion } from "../../../context/Actions/turnos/cancelacion";
import Tooltip from "../../../../global/component/Genericos/Tooltip/Tooltip";
import TildeOkAbonado from "../../../assets/images/generico/TildeOkAbonado";
import PagarSeguro from "../../../assets/images/generico/PagarSeguro";
import CirculoInformacion from "../../../assets/images/generico/CirculoInformacion";
import DocumentoIcon from "../../../assets/images/generico/DocumentoIcon";
import { IonSpinner } from "@ionic/react";
import CirculoRojo from "../../../assets/images/generico/CirculoRojo";
import { GlobalContext } from "../../../../global/context/Provider";
import { setPasoMultiTab } from "../../../context/Actions/multiTab/multiTab";
import { mercadoPagoReset } from "_+_Portal/context/Actions/mercadoPago/mercadoPago";

const CardVideoLlamada = ({
  item,
  itemVC: itemVCProp,
  idPacienteFamiliar,
  recargoTurnos,
}) => {
  // Cuando videoConsultaDto es null (turno agendado pero la sala aún no fue configurada),
  // usamos los datos del turno para mostrar el estado "Agendada" sin crashear.
  const itemVC = itemVCProp ?? {
    estado: "P",
    fechaProgramada: item.fecha,
    fechaCambioEstado: item.fecha,
    idEspecialidad_desc: item.especialidad,
    idMedico_desc: item.medico,
    medCalling: false,
    opeCalling: false,
    roomId: null,
    roomIdOpe: null,
  };
  const {
    modalDispatch,
    cancelacionState,
    motivoCancelacionState,
    turnosPacienteState,
    turnosPacienteDispatch,
    cancelacionDispatch,
    textosState,
    ordenEstudioState,
    mercadoPagoDispatch,
  } = useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch } = useContext(GlobalContext);
  const { multiTabDispatch, multiTabState } = useContext(PortalContext);

  let config = localStorage.getItem("config");
  let mercadoPagoJson = JSON.parse(config).mercadoPago;

  const [flgFila, setFlgFila] = useState(true);
  const [flgSalirFila, setFlgSalirFila] = useState(true);
  const [flgValidacion, setFlgValidacion] = useState(false);
  const [estadoFilaVirtual, setEstadoFilaVirtual] = useState({
    id: item.idturno,
    estado: "V",
  });

  let fechaHoy = new Date();

  let fechaCard = new Date(itemVC.fechaCambioEstado);

  let fechaHoraSumada = new Date(itemVC.fechaProgramada);
  fechaHoraSumada.setMinutes(fechaHoraSumada.getMinutes() + 60);

  let mediaHoraAntes = new Date(itemVC.fechaProgramada);
  mediaHoraAntes.setMinutes(mediaHoraAntes.getMinutes() - 30);

  const ingresarFilaVirtual = () => {
    setPasoMultiTab(5)(multiTabDispatch);
    if (fechaHoy > fechaHoraSumada) {
      showToaster(
        {
          texto:
            "En este momento está fuera del rango horario, puede ingresar al turno de video consulta 30 minutos antes y hasta 60 minutos después del horario programado.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      wsCambioEstadoVideoLlamada(
        item.idturno,
        estadoFilaVirtual
      )(turnosPacienteDispatch);
      setFlgFila(false);
    }
  };

  const validaCancelacion = () => {
    showModalCancelarTurno();
    wsGetValidaCancelacion(item.idturno, idPacienteFamiliar)(cancelacionDispatch);
    setFlgValidacion(true);
  };

  const trackButton = useRef();

  const showModalCancelarTurno = () => {
    showModal(
      "Turnos/MensajeCancelarTurno/MensajeCancelarTurno",
      {
        titulo: "Cancelar turno",
        texto: `Desea cancelar ${
          item.videoConsulta === true ? "la video consulta" : "su turno"
        } de ${itemVC.idEspecialidad_desc} del ${getDiaStrTurno(itemVC.fechaProgramada)} ${getDiaStrTurno(
          itemVC.fechaProgramada,
          true
        )} a las ${item.hora} ${amOrPm(item.hora)} ?`,
        items: item.idProtocolo
          ? motivoCancelacionState.motivoCancelacion.laboratorio
          : motivoCancelacionState.motivoCancelacion.turnos,
        idturno: item.idturno,
        idProtocolo: item.idProtocolo,
        idTurnoSesion: item.idTurnoSesion,
        idPacienteFamiliar,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };
  const showModalLlamada = () => {
    // if (multiTabState.multiTab.paso !== 5) {
    //   setPasoMultiTab(5)(multiTabDispatch);
    // }
    if (itemVC.idEspecialidad_desc && itemVC.fechaProgramada && itemVC.idMedico_desc) {
      showModal(
        "Turnos/VideoLlamada/VideoLlamada",
        {
          titulo: "Video Consulta",
          especialidad: itemVC.idEspecialidad_desc,
          medico: itemVC.idMedico_desc,
          fechaTurno: itemVC.fechaProgramada,
          horaProgramada: item.hora,
          estado: itemVC.estado,
          idturno: item.idturno,
          fechaCambioEstado: itemVC.fechaCambioEstado,
          roomId: itemVC.roomId,
          roomIdOpe: itemVC.roomIdOpe,
          dissmiss: dissmiss,
        },
        {},
        "centro",
        true
      )(modalDispatch);
    }
  };

  const showModalAbonarTurno = () => {
    showModal(
      "Turnos/AbonaTurno/AbonaTurno",
      {
        idturno: item.idturno,
        idProtocolo: item.idProtocolo,
        monto: item.monto,
        fecha: itemVC.fechaProgramada,
        hora: item.hora,
        centro: item.centro,
        especialidad: itemVC.idEspecialidad_desc,
        dismiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const showModalAdjuntarOrden = () => {
    showModal(
      "Genericos/ModalSubirOrden/ModalSubirOrden",
      {
        idturno: item.idturno,
        multimedia: item.multimedia,
        idProtocolo: item.idProtocolo,
        idPacienteFamiliar,
        dissmiss: dissmiss,
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  useEffect(() => {
    if (itemVC.medCalling && itemVC.estado === "E") {
      showModalLlamada();
    }
    if ((itemVC.estado === "D" || itemVC.estado === "P" || itemVC.estado === "H") && itemVC.opeCalling)
      showModalLlamada();
    //eslint-disable-next-line
  }, [turnosPacienteState.turnosPaciente.data]);

  useEffect(() => {
    setFlgFila(true);
    //eslint-disable-next-line
  }, [itemVC.estado]);

  const dissmiss = (origen, estado, mensaje) => {
    if (origen === "mercadoPago") {
      if (estado) {
        showToaster(
          {
            texto: mensaje,
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        showToaster(
          {
            texto: mensaje,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
      hideModal()(modalDispatch);
      mercadoPagoReset()(mercadoPagoDispatch);
      recargoTurnos();
    } else {
      hideModal()(modalDispatch);
      limpiarTipoTurno()(turnosPacienteDispatch);
    }
  };

  useEffect(() => {
    if (flgValidacion === true) {
      showModalCancelarTurno();
    } else if (cancelacionState.cancelacion.error) {
      showToaster(
        {
          texto: cancelacionState.cancelacion.validaCancelacion,
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }

    //eslint-disable-next-line
  }, [flgValidacion]);

  return (
    <div ref={trackButton} className={`ptur-cardVideoLlamada`}>
      <CardTemplate
        classTemplateBox={`ptur-card-template-box`}
        classTittleBox="ptur-card-turno-titleBox"
        tituloCard={`${itemVC.idEspecialidad_desc}`}
        iconTituloCard={true}
        imgTittle={<TurnoVideoConsultaIcon />}
        bodyCard={
          <React.Fragment>
            <div className="ptur-card-cardVideoLlamada-body">
              <div className="ptur-card-cardVideoLlamada-body-datos">
                <span className="rb18b">
                  {getDiaStrTurno(itemVC.fechaProgramada)}{" "}
                  <span className="rb18l">{getDiaStrTurno(itemVC.fechaProgramada, true)}</span>
                </span>
                <span className="ptur-card-cardVideoLlamada-horario rb18b">
                  Horario:{" "}
                  <span className="rb18l">
                    {item.hora} {amOrPm(item.hora)}
                  </span>
                </span>
                <div className="ptur-card-cardVideoLlamada-lista">
                  <ul>
                    {itemVC.idMedico_desc && (
                      <li>
                        Especialista:{" "}
                        <span className="rb16b">{camelize(itemVC.idMedico_desc)}</span>
                      </li>
                    )}
                  </ul>
                </div>
                <div>
                  <span className="rb16b"> Consulta:</span>
                  <span> Video Consulta</span>
                </div>
              </div>

              <>
                <div className="ptur-card-cardVideoLlamada-vc">
                  {itemVC.estado === "P" ? (
                    <>
                      {fechaHoy >= mediaHoraAntes ? (
                        <>
                          <button
                            className={
                              flgFila
                                ? "ptur-card-cardVideoLlamada-vcBtn bgc-latex30"
                                : "ptur-card-cardVideoLlamada-vcBtnDsbFilaEspera"
                            }
                            onClick={flgFila ? ingresarFilaVirtual : () => {}}
                          >
                            <div
                              className={
                                flgFila
                                  ? "ptur-card-cardVideoLlamada-iconoLlamada"
                                  : "ptur-card-cardVideoLlamada-iconoLlamadaDsb"
                              }
                            >
                              <VideoConsultaIcon color={"var(--color-white)"} />
                              <span className="ptur-card-cardVideoLlamada-vcText rb16m">
                                Ingresar en fila de espera virtual
                              </span>
                            </div>
                          </button>
                          <span className="ptur-card-cardVideoLlamada-vcTextInfo rb14m">
                            Le pedimos que por favor ingresar a la fila de
                            espera virtual para que nuestros operadores puedan
                            realizar su recepcion online.
                          </span>
                        </>
                      ) : (
                        <>
                          <button
                            className="ptur-card-cardVideoLlamada-vcBtn bgc-grey65"
                            style={{ cursor: "auto" }}
                          >
                            <span className="ptur-card-cardVideoLlamada-vcText rb16m">
                              Video consulta agendada
                            </span>
                          </button>
                          <span className="ptur-card-cardVideoLlamada-vcTextInfo rb14m">
                            Este turno se encuentra agendado en la modalidad de
                            Video Consulta. A partir de 30 minutos antes del
                            turno y hasta el horario del mismo, podrá ingresar
                            desde esta misma pantalla a la fila de espera
                            virtual para comenzar con su proceso de recepción.
                          </span>
                        </>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {itemVC.estado === "V" ? (
                    <>
                      <button
                        className={
                          flgSalirFila
                            ? "ptur-card-cardVideoLlamada-vcBtn bgc-latex30"
                            : "ptur-card-cardVideoLlamada-vcBtnDsbFilaEspera"
                        }
                        onClick={flgSalirFila ? showModalLlamada : () => {}}
                      >
                        <span className="ptur-card-cardVideoLlamada-vcText rb16m">
                          Aguardando en fila de espera virtual
                        </span>
                      </button>
                      <span className="ptur-card-cardVideoLlamada-vcTextInfo rb14m">
                        Le pedimos que por favor aguarde un momento para que
                        nuestros opeardores puedan realizar su recepción online.
                        <p>
                          Desde:{" "}
                          {fechaCard.getDate() +
                            "/" +
                            (fechaCard.getMonth() + 1) +
                            "/" +
                            fechaCard.getFullYear()}{" "}
                          {fechaCard.getHours() +
                            ":" +
                            (fechaCard.getMinutes() < 10
                              ? "0" + fechaCard.getMinutes()
                              : fechaCard.getMinutes())}
                        </p>
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                  {itemVC.estado === "D" ? (
                    <>
                      <button
                        className="ptur-card-cardVideoLlamada-vcBtn bgc-latex30"
                        style={{ cursor: "auto" }}
                      >
                        <span className="ptur-card-cardVideoLlamada-vcText rb16m">
                          Operador realizando recepción online
                        </span>
                      </button>
                      <span className="ptur-card-cardVideoLlamada-vcTextInfo rb14m">
                        El recepcionista está realizando su recepción online.
                        Por favor, aguarde un momento. Desde:{" "}
                        {fechaCard.getDate() +
                          "/" +
                          (fechaCard.getMonth() + 1) +
                          "/" +
                          fechaCard.getFullYear()}{" "}
                        {fechaCard.getHours() +
                          ":" +
                          (fechaCard.getMinutes() < 10
                            ? "0" + fechaCard.getMinutes()
                            : fechaCard.getMinutes())}
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                  {itemVC.estado === "L" ? (
                    <>
                      <button
                        className="ptur-card-cardVideoLlamada-vcBtn bgc-latex30"
                        style={{ cursor: "auto" }}
                      >
                        <span className="ptur-card-cardVideoLlamada-vcText rb16m">
                          Turno recepcionado
                          <p>Aguardando al profesional</p>
                        </span>
                      </button>
                      <span className="ptur-card-cardVideoLlamada-vcTextInfo rb14m">
                        El profesional lo llamará en breve. Por favor, aguarde
                        un momento.{" "}
                        <p>
                          Desde:{" "}
                          {fechaCard.getDate() +
                            "/" +
                            (fechaCard.getMonth() + 1) +
                            "/" +
                            fechaCard.getFullYear()}{" "}
                          {fechaCard.getHours() +
                            ":" +
                            (fechaCard.getMinutes() < 10
                              ? "0" + fechaCard.getMinutes()
                              : fechaCard.getMinutes())}
                        </p>
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                  {itemVC.estado === "E" ? (
                    <>
                      <button
                        className={
                          itemVC.medCalling
                            ? "ptur-card-cardVideoLlamada-vcBtn bgc-broccoli"
                            : "ptur-card-cardVideoLlamada-vcBtn bgc-grey65"
                        }
                        onClick={showModalLlamada}
                      >
                        <div
                          className={
                            itemVC.medCalling
                              ? "ptur-card-cardVideoLlamada-iconoLlamada"
                              : "ptur-card-cardVideoLlamada-iconoLlamadaDsb"
                          }
                        >
                          <VideoConsultaIcon color={"var(--color-white)"} />
                          <span className="ptur-card-cardVideoLlamada-vcText rb16m">
                            Atender llamada del profesional
                          </span>
                        </div>
                      </button>
                      <span className="ptur-card-cardVideoLlamada-vcTextInfo rb14m">
                        El profesional lo esta llamando para realizar la Video
                        Consulta. Por favor, atienda presionando el botón verde.
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                  {itemVC.estado === "A" ? (
                    <>
                      <button
                        className="ptur-card-cardVideoLlamada-vcBtn bgc-broccoli"
                        onClick={showModalLlamada}
                      >
                        <div className="ptur-card-cardVideoLlamada-iconoLlamada">
                          <VideoConsultaIcon color={"var(--color-white)"} />
                          <span className="ptur-card-cardVideoLlamada-vcText rb16m">
                            Video consulta en curso
                          </span>
                        </div>
                      </button>
                      <span className="ptur-card-cardVideoLlamada-vcTextInfo rb14m">
                        Para volver a unirse a la llamada presione el botón
                        verde
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                  {itemVC.estado === "H" ? (
                    <>
                      <button
                        className={
                          "ptur-card-cardVideoLlamada-vcBtn bgc-latex30"
                        }
                        style={{ cursor: "auto" }}
                      >
                        <span className="ptur-card-cardVideoLlamada-vcText rb16m">
                          En Hold
                        </span>
                      </button>
                      <span className="ptur-card-cardVideoLlamada-vcTextInfo rb14m">
                        Paciente con problemas Administrativos. Desde:{" "}
                        {fechaCard.getDate() +
                          "/" +
                          (fechaCard.getMonth() + 1) +
                          "/" +
                          fechaCard.getFullYear()}{" "}
                        {fechaCard.getHours() +
                          ":" +
                          (fechaCard.getMinutes() < 10
                            ? "0" + fechaCard.getMinutes()
                            : fechaCard.getMinutes())}
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                  {itemVC.estado === "F" ? (
                    <>
                      <button
                        className="ptur-card-cardVideoLlamada-vcBtn bgc-grey65"
                        style={{ cursor: "auto" }}
                      >
                        <span className="ptur-card-cardVideoLlamada-vcText rb16m">
                          Videoconsulta finalizada
                        </span>
                      </button>
                      <span className="ptur-card-cardVideoLlamada-vcTextInfo rb14m">
                        Videoconsulta finalizada
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                </div>

                <div className="ptur-card-cardVideoLlamada-body-greyLine"></div>
                {item.requiereAutorizacion ? (
                  <div className="ptur-cardVideoLlamada-reqAutorizacion">
                    <Tooltip
                      descripcion={
                        textosState.textos.data.reqAutorizacion.descripcion
                      }
                      data={
                        <>
                          <AlertIcon color={"var(--color-danger)"} />
                          <span className="ptur-card-cardVideoLlamada-body-alertText rb14m c-danger">
                            Requiere Autorizacion
                          </span>
                        </>
                      }
                      customCss="ptur-card-cardVideoLlamada-tooltip-reqAutorizacion"
                    />
                  </div>
                ) : (
                  ""
                )}
                {item.flgSaldada && (
                  <div className="ptur-cardVideoLlamada-abonado">
                    {" "}
                    <TildeOkAbonado />
                    <span className="noSeleccionable rb18m c-broccoli">
                      Turno abonado
                    </span>
                  </div>
                )}
                {mercadoPagoJson === true
                  ? item.monto > 0 &&
                    !item.flgSaldada &&
                    ((item.subeFotoOrden && item.estadoOrden === "Validado") ||
                      !item.subeFotoOrden) && (
                      <div className="ptur-cardVideoLlamada-abonar">
                        <button
                          className="ptur-card-cardVideoLlamada-ordenOpc-btnOrden rb16m c-white"
                          onClick={() => showModalAbonarTurno()}
                        >
                          <PagarSeguro />
                          <span>Abonar turno</span>
                        </button>
                      </div>
                    )
                  : ""}
                {item.subeFotoOrden && !item.tieneFotoOrden ? (
                  <div className="ptur-card-cardVideoLlamada-ordenOpc-box">
                    <button
                      className="ptur-card-cardVideoLlamada-ordenOpc-btnOrden rb16m c-white"
                      onClick={() => showModalAdjuntarOrden()}
                    >
                      {ordenEstudioState.ordenEstudio.loading ? (
                        <IonSpinner name="lines-small" />
                      ) : (
                        <>
                          <DocumentoIcon />
                          <span>Subir orden médica</span>
                        </>
                      )}
                    </button>
                  </div>
                ) : (
                  ""
                )}
                {item.estadoOrden === "Pendiente" &&
                item.tieneFotoOrden &&
                item.multimedia.length > 0 ? (
                  <>
                    <div className="ptur-cardVideoLlamada-OrdenEnVerificacion">
                      <Tooltip
                        descripcion={
                          "Luego de la verificación, su estudio podría tener un costo"
                        }
                        data={
                          <>
                            <div className="ptur-cardVideoLlamada-OrdenEnVerificacion-iconTxt">
                              <CirculoInformacion />
                              <span className="underline noSeleccionable rb18m c-latex30">
                                Orden médica en verificación
                              </span>
                            </div>
                          </>
                        }
                        customCss="ptur-card-cardVideoLlamada-tooltip-estadosPendiente"
                      />
                    </div>
                    <div className="ptur-card-cardVideoLlamada-subirOrdenAdicional">
                      <button
                        className="ptur-card-cardVideoLlamada-subirOrdenAdicional-Btn"
                        onClick={() => showModalAdjuntarOrden()}
                      >
                        <span className="ptur-card-cardVideoLlamada-vc-cancelarText rb16m">
                          Editar orden
                        </span>
                      </button>
                    </div>
                  </>
                ) : (
                  ""
                )}
                {item.estadoOrden === "Rechazado" && (
                  <>
                    <div className="ptur-cardVideoLlamada-rechazado">
                      <Tooltip
                        descripcion={item.motivoRechazoObservacion}
                        data={
                          <>
                            <div className="ptur-cardVideoLlamada-OrdenEnVerificacion-iconTxt">
                              <CirculoRojo />
                              <span className="underline noSeleccionable rb18m c-danger">
                                Orden médica rechazada
                              </span>
                            </div>
                          </>
                        }
                        customCss="ptur-card-cardVideoLlamada-tooltip-estados"
                      />
                    </div>
                    <div className="ptur-card-cardVideoLlamada-ordenOpc-box">
                      <button
                        className="ptur-card-cardVideoLlamada-ordenOpc-btnOrden rb16m c-white"
                        onClick={() => showModalAdjuntarOrden()}
                      >
                        {turnosPacienteState.turnosPaciente.loading ? (
                          <IonSpinner name="lines-small" />
                        ) : (
                          "Subir orden médica"
                        )}
                      </button>
                    </div>
                  </>
                )}
                {item.estadoOrden === "Validado" && (
                  <div className="ptur-cardVideoLlamada-abonado">
                    <TildeOkAbonado />
                    <span className="noSeleccionable rb18m c-broccoli">
                      Orden médica verificada
                    </span>
                  </div>
                )}
                <div className="ptur-card-cardVideoLlamada-vc-cancelarBox">
                  <button
                    className="ptur-card-cardVideoLlamada-vc-cancelarBtn"
                    onClick={validaCancelacion}
                  >
                    <span className="ptur-card-cardVideoLlamada-vc-cancelarText rb16m">
                      Cancelar turno
                    </span>
                  </button>
                </div>
              </>

              <div className="ptur-card-cardVideoLlamada-body-alertBox">
                <button className="ptur-card-cardVideoLlamada-body-alertBtn">
                  {textosState.textos.data.compromisoTurno?.descripcion ===
                    null ||
                  textosState.textos.data.compromisoTurno?.descripcion ===
                    undefined ? (
                    ""
                  ) : (
                    <Tooltip
                      descripcion={
                        textosState.textos.data?.compromisoTurno?.descripcion
                      }
                      data={
                        <>
                          <AlertIcon />
                          <span className="ptur-card-cardTurno-body-alertText rb14m">
                            Tu compromiso reservando turnos
                          </span>
                        </>
                      }
                      customCss="ptur-card-cardVideoLlamada-tooltip"
                    />
                  )}
                </button>
              </div>
            </div>
          </React.Fragment>
        }
      />
    </div>
  );
};

export default CardVideoLlamada;
